module["exports"] = [
  "West-Vlaanderen",
  "Oost-Vlaanderen",
  "Vlaams-Brabant",
  "Antwerpen",
  "Limburg",
  "Brussel"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nl_BE/address/state.js
// module id = 3323
// module chunks = 1610